/**
 * Allow-list of URL paths where the global task notification drawer may open.
 * @module isTasksNotificationDrawerAllowedPathname
 */

/**
 * Pathnames (React Router `location.pathname`) where the notification drawer
 * is permitted to auto-open or be opened manually.
 *
 * Add entries here to enable the drawer on additional screens.
 */
const TASKS_NOTIFICATION_DRAWER_ALLOWED_PATHS = [
  "/worklists/medical-pa-orders",
] as const;

/**
 * Returns whether the task notification drawer is allowed on the given pathname.
 *
 * @param pathname - Current location pathname from React Router.
 * @returns True when the pathname matches an allow-listed screen.
 */
export const isTasksNotificationDrawerAllowedPathname = (
  pathname: string,
): boolean => {
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  return TASKS_NOTIFICATION_DRAWER_ALLOWED_PATHS.some(
    (allowed) => normalized === allowed,
  );
};
